import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Map of old URLs to new redirect destinations
const REDIRECT_MAP: Record<string, string> = {
  '/creative-services': '/',
  '/marketing': '/services/marketing',
  '/near-me': '/services/website-design',
  '/pricing': '/portfolio',
  '/software': '/services/software',
  '/photography': '/services/photography',
  '/video': '/services/marketing',
  '/real-estate-media': '/services/real-estate-media'
};

const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Check if the current path is in our redirect map
    if (REDIRECT_MAP[path]) {
      console.log(`Redirecting from ${path} to ${REDIRECT_MAP[path]}`);
      
      // Use navigate for internal redirects, window.location for external
      if (REDIRECT_MAP[path].startsWith('http')) {
        window.location.href = REDIRECT_MAP[path];
      } else {
        navigate(REDIRECT_MAP[path], { replace: true });
      }
    }
  }, [location.pathname, navigate]);
  
  // This component doesn't render anything
  return null;
};

export default RedirectHandler;
